<template>
  <div>
    <div id="graphContainer" class="graph-container"></div>

    <side-bar :pouTempId="pouTempId"></side-bar>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row v-if="editedObj.elementType === 'powerRail'">
              <v-col cols="6">
                <v-text-field label="Pin number" type="number" v-model.number="editedObj.pinNumber"></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-select label="Type" :items="powerRailTypes" v-model="editedObj.type"></v-select>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'contact'">
              <v-col cols="6">
                <v-select label="Modifier" :items="contactModifiers" v-model="editedObj.modifier"></v-select>
              </v-col>

              <v-col cols="6">
                <v-text-field label="Variable" v-model="editedObj.variable"></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'coil'">
              <v-col cols="6">
                <v-select label="Modifier" :items="coilModifiers" v-model="editedObj.modifier"></v-select>
              </v-col>

              <v-col cols="6">
                <v-text-field label="Variable" v-model="editedObj.variable"></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'comment'">
              <v-col cols="12">
                <v-textarea label="Comment" v-model="editedObj.value"></v-textarea>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'connection'">
              <v-col cols="6">
                <v-select label="Type" :items="connectionTypes" v-model="editedObj.type"></v-select>
              </v-col>

              <v-col cols="6">
                <v-text-field label="Name" v-model="editedObj.name"></v-text-field>
              </v-col>
            </v-row>

            <v-row
              v-if="['standardFunctionBlockPou', 'additionalFunctionBlockPou'].includes(editedObj.elementType)"
            >
              <v-col cols="6">
                <v-text-field label="Name" v-model="editedObj.variableName"></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-text-field
                  type="number"
                  label="Execution Order"
                  v-model.number="editedObj.executionOrder"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row
              v-if="['typeConversionPou', 'numericalPou', 'arithmeticPou', 'timePou', 'bitShiftPou', 'bitWisePou', 'selectionPou', 'comparisionPou', 'characterStringPou'].includes(editedObj.elementType)"
            >
              <v-col cols="6">
                <v-text-field
                  type="number"
                  label="Execution Order"
                  v-model.number="editedObj.executionOrder"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="editedObj.elementType === 'userDefinedPou'">
              <v-col cols="6">
                <v-text-field
                  type="number"
                  label="Execution Order"
                  v-model.number="editedObj.executionOrder"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" text type="submit" @click="saveCell">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const stringify = require("json-stringify-safe");
const { create } = require("xmlbuilder2");
const convert = require("xml-js");

import { map, filter, find, some, values, flatten, isNil } from "lodash";

import ldElements from "./ldElements.json";
import commonElements from "./commonElements.json";
import SideBar from "./SideBar";
import images from "./images";
import graph from "src/mixins/graph";

export default {
  name: "LDGraph",
  props: ["pouTempId"],
  components: { SideBar },
  mixins: [graph],
  data() {
    return {
      name: "LD",

      powerRailTypes: [
        { text: "Left Power Rail", value: "leftPowerRail" },
        { text: "Right Power Rail", value: "rightPowerRail" },
      ],
      contactModifiers: [
        { text: "Normal", value: "normal" },
        { text: "Negated", value: "negated" },
        { text: "Rising Edge", value: "risingEdge" },
        { text: "Falling Edge", value: "fallingEdge" },
      ],
      coilModifiers: [
        { text: "Normal", value: "normal" },
        { text: "Negated", value: "negated" },
        { text: "Set", value: "set" },
        { text: "Reset", value: "reset" },
        { text: "Rising Edge", value: "risingEdge" },
        { text: "Falling Edge", value: "fallingEdge" },
      ],
    };
  },
  computed: {
    vars() {
      return find(this.$store.state.pous, { tempId: this.pouTempId }).variables;
    },
    pous() {
      return this.$store.state.pous;
    },
    pou() {
      return find(this.$store.state.pous, { tempId: this.pouTempId });
    },
  },
};
</script>

<style lang="scss" scoped>
.graph-container {
  flex-grow: 2;
  cursor: default;
  background: url("https://jgraph.github.io/mxgraph/javascript/examples/editors/images/grid.gif");
}
</style>
